import reduce from 'lodash/fp/reduce'
import toPairs from 'lodash/fp/toPairs'
import sortBy from 'lodash/fp/sortBy'
import flow from 'lodash/fp/flow'
import partition from 'lodash/fp/partition'
import fromPairs from 'lodash/fp/fromPairs'

export default function shippingConstants(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_SHIPPING_CONSTANTS': {
      return action.payload
    }

    default: {
      return state
    }
  }
}

export function getAllShippingCountries(state) {
  return flow(
    toPairs,
    sortBy(pair => pair[1]), // Sort by name
    partition(pair => pair[0] === 'US'), // Ensure US is first
    reduce((memo, countries) => memo.concat(countries), []),
    fromPairs,
  )(state.international_shipping_countries)
}
